/* eslint-disable */
import _ from 'lodash';

const getShowProperty = (id) => {
  const arr = JSON.parse(localStorage.getItem('seenNotifications'));

  if(arr && arr.includes(id)){
    return false;
  }

  return true;
};

export const getNotifications = (context, history) => ([
   {
    id: 1,
    title: 'Setup Stripe Account',
    message: 'This account does not have a Stripe account Click on this message to connect a Stripe account so you may receice funds collected by Sparxo',
    callback: () => history.push({ pathname: '/settings/account', state: { isPaymentModalOpen: true } }),
    show: !!!_.get(context, 'profileCurrent.email', false)
  },
  {
    id: 2,
    title: 'Add Company Description',
    message: 'Let customers know who you are. Your company name shows up in many places. like in the ticket email and in credit card statements. Click this message to make sure no one is confused.',
    callback: () => history.push({ pathname: '/settings/account', state: { isPageOrdModalOpen: true } }),
    show: !!!_.get(context, 'profileCurrent.company_name', false)
  },
   {
    id: 3,
    title: 'Add Contact Information',
    message: 'Make sure your event goers know how to contact you. Click this message to profiled a contact number and email address.',
    callback: () => context.handleToggleEditProfileModal(true),
    show: !!!_.get(context, 'profileCurrent.email', false) && !!_.get(context, 'profileCurrent.phone_number', false)
  },
  {
    id: 4,
    title: 'Introduce Sparxo to your network',
    message: 'Click here to invite more people You will earn a 30% discount for one event for each account that is created through this invite that sells 200 or more tickets.',
    callback: () => history.push({ pathname: '/settings/referrals'}),
    show: getShowProperty(4)
  },
  {
    id: 5,
    title: 'Tutorial - Create your first event',
    message: 'Is this your first time using Sparxo? Click here to watch short Youtube video on a quick walkthrough on creating your first event',
    callback: () => window.open('https://youtu.be/8zdgGFamgVc', '_blank'),
    show: getShowProperty(5)
  }
]);
